import React from 'react'

// Components
import {
    Button,
    ButtonGroup,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import GiftCertificateItem from '@app/components/gift-certificate-item'
import {FormattedMessage} from 'react-intl'

// Hooks
import {useDisclosure} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {useShopperBasketsMutation} from '@salesforce/commerce-sdk-react'
import {useToast} from '@app/hooks/use-toast'
import {useCurrentBasket} from '@app/hooks/use-current-basket'

export default function GiftCertificateItemWithActions(props) {
    const {giftCertificateItem} = props

    const intl = useIntl()
    const toast = useToast()
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {data: basket} = useCurrentBasket()

    const {mutateAsync: removeGiftCertificateMutation} = useShopperBasketsMutation(
        'removeGiftCertificateItemFromBasket'
    )

    const handleRemoveGiftCertificate = () => {
        removeGiftCertificateMutation(
            {
                parameters: {
                    basketId: basket?.basketId,
                    giftCertificateItemId: giftCertificateItem.giftCertificateItemId
                }
            },
            {
                onSuccess: () => {
                    toast({
                        title: intl.formatMessage({
                            id: 'giftcard.toast.removed',
                            defaultMessage: 'Online Gift Card removed from the cart'
                        })
                    })
                    onClose()
                },
                onError: () => {
                    toast({
                        title: intl.formatMessage({
                            id: 'giftcard.toast.error.remove',
                            defaultMessage:
                                'Something went wrong while removing your online gift card from the cart'
                        }),
                        variant: 'error'
                    })
                }
            }
        )
    }

    return (
        <>
            <GiftCertificateItem {...props}>
                <ButtonGroup>
                    <Button variant="link" onClick={onOpen}>
                        <FormattedMessage
                            defaultMessage="Remove"
                            id="cart_secondary_button_group.action.remove"
                        />
                    </Button>
                </ButtonGroup>
            </GiftCertificateItem>

            {/* Modal for removing GCs from basket */}
            <Modal isOpen={isOpen} onClose={onClose} size="small" isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalHeader pr={25} textTransform="uppercase">
                        <FormattedMessage
                            defaultMessage="Confirm remove gift card"
                            id="giftcard.checkout.modal.title"
                        />
                    </ModalHeader>
                    <ModalBody>
                        <Text variant="bodyLarge1" mb="1rem">
                            <FormattedMessage
                                defaultMessage="Are you sure you want to remove the gift card from your order?"
                                id="giftcard.checkout.modal.text"
                            />
                        </Text>
                    </ModalBody>
                    <ModalFooter
                        width="full"
                        p="0"
                        justifyContent="space-between"
                        flexWrap={['wrap', null, 'nowrap', 'nowrap']}
                        gap={16}
                    >
                        <Button
                            variant="secondary"
                            onClick={onClose}
                            flex={['1 0 100%', null, 'auto']}
                            whiteSpace={['wrap', null, 'nowrap']}
                        >
                            <FormattedMessage
                                defaultMessage="No, keep gift card"
                                id="giftcard.checkout.modal.button.cancel"
                            />
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleRemoveGiftCertificate}
                            flex={['1 0 100%', null, 'auto']}
                            whiteSpace={['wrap', null, 'nowrap']}
                        >
                            <FormattedMessage
                                defaultMessage="Yes, remove"
                                id="giftcard.checkout.modal.button.valid"
                            />
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

GiftCertificateItemWithActions.propTypes = GiftCertificateItem.propTypes
